import React, { useEffect, useState } from 'react';
import reframe from 'nike-re-framejs';
import { formatMoney } from '@/common/client';
import axios from 'axios/index';
import { getUrl } from '@/common/oldMobile';
import { catcher } from '@/_http/utils';

function InformationDutyStatistics({
    t1: internet_bets,
    t2: internet_casino,
    t3: stakes_monthly,
    t4: winnings_monthly,
    t5: stakes_overall,
    t6: winnings_overall
}) {
    const [data, setData] = useState(null);
    useEffect(() => {
        axios
            .get(getUrl('INFORMATION_DUTY_STATS'))
            .then(stats => {
                if (stats) {
                    setData(stats);
                    reframe.dispatch(['informationDuty.setLoaded']);
                }
            })
            .catch(catcher.swallow);
    }, []);
    const sportsbook = data && data.sportsbook;
    const casino = data && data.casino;
    return (
        <div>
            <InformationDutyModule
                header={internet_bets}
                data={sportsbook}
                stakes={stakes_monthly}
                winnings={winnings_monthly}
                stakes_overall={stakes_overall}
                winnings_overall={winnings_overall}
                atid="sportsbook"
            />
            <InformationDutyModule
                header={internet_casino}
                data={casino}
                stakes={stakes_monthly}
                winnings={winnings_monthly}
                stakes_overall={stakes_overall}
                winnings_overall={winnings_overall}
                atid="casino"
            />
        </div>
    );
}

function InformationDutyModule({ header, stakes, winnings, data, atid, stakes_overall, winnings_overall }) {
    return (
        <div className="values-box">
            <p className="value-box-header">{header}</p>
            {data ? (
                <>
                    <p className="stakes">
                        {stakes}{' '}
                        <b data-atid={atid + '_monthly_stakes'}>{formatMoney(data.monthly_stakes || 0, 'EUR')}</b>
                    </p>
                    <p>
                        {winnings}{' '}
                        <b data-atid={atid + '_monthly_winnings'}>{formatMoney(data.monthly_winnings || 0, 'EUR')}</b>
                    </p>
                    <p className="stakes">
                        {stakes_overall}{' '}
                        <b data-atid={atid + '_overall_stakes'}>{formatMoney(data.stakes || 0, 'EUR')}</b>
                    </p>
                    <p>
                        {winnings_overall}{' '}
                        <b data-atid={atid + '_overall_winnings'}>{formatMoney(data.winnings || 0, 'EUR')}</b>
                    </p>
                </>
            ) : (
                <Empty />
            )}
        </div>
    );
}

function Empty() {
    return (
        <>
            <p>
                <span className="mini-preloader-ng" />
                &nbsp;
            </p>
            <p>&nbsp;</p>
        </>
    );
}

export default InformationDutyStatistics;
